import { initializeKeycloak } from 'app/store/auth';
import type { ReduxNonApiAction, ReduxActionOutcome } from 'app/store/storeTypes';
import { doGetApplicationConfiguration } from 'app/store/applicationConfig/actions.js';
import { doLoadAttributeDefinitions } from 'app/store/attributes/actions.js';
import { doLoadGlossary } from 'app/store/glossary/actions.js';
import { doLoadProjects } from 'app/store/projects/actions.js';
import { doListSnowflakeQueries } from 'app/store/snowflakeQueries/actions.js';
import {
    doGetUserHasAcceptedTerms,
    doWebsocketAuth,
    doListUserDetails
} from 'app/store/users/actions.js';
import { SIGN_IN_KEYCLOAK, INITIATE_KEYCLOAK } from 'app/store/users/types.js';
import { INITIALIZE_APPLICATION } from './types';

export const doInitiateKeycloak = () =>
    ({
        type: INITIATE_KEYCLOAK,
        effect: ({ store }) => {
            initializeKeycloak(store);
        }
    }) as const satisfies ReduxNonApiAction;

export const doInitiateApplication = ({ username, jwt }: { username?: string; jwt?: string }) =>
    ({
        type: INITIALIZE_APPLICATION,
        effect: ({ store }) => {
            store.dispatch({
                type: SIGN_IN_KEYCLOAK.SUCCEEDED,
                payload: { username }
            });
            store.dispatch(doWebsocketAuth(jwt));
            store.dispatch(doGetApplicationConfiguration());
            store.dispatch(doGetUserHasAcceptedTerms());
            store.dispatch(doLoadProjects());
            store.dispatch(doListUserDetails());
            store.dispatch(doLoadAttributeDefinitions());
            store.dispatch(doLoadGlossary());
            store.dispatch(doListSnowflakeQueries());
        }
    }) as const satisfies ReduxNonApiAction;

export type StartupActionOutcomes =
    | ReduxActionOutcome<ReturnType<typeof doInitiateApplication>>
    | ReduxActionOutcome<ReturnType<typeof doInitiateKeycloak>>;
